import { Component, ViewChild, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { restURL } from "../../../Models/restURL";
import { LanguageService } from "../../../Services/languageService";
import { userService } from "../../../Services/userService";
import { TranslateService } from "@ngx-translate/core";
import { motorProposalService } from "../../../Services/motorProposalService";
import { HttpClient } from "@angular/common/http";
import { mdlAddSequnceNoReq } from "../../../Models/mdlAddSequnceNoReq";
import { MotorDriverMdl } from "../../../Models/MotorDriverMdl";
import { mdlBindInfo } from "../../../Models/mdlBindInfo";
import { mdlDriverInfoRes } from "../../../Models/mdlDriverInfoRes";
import { mdlPayloadRequest } from "../../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../../Models/mdlPayloadResponse";
import Swal from 'sweetalert2';
import { mdlDriverInfoReq } from "../../../Models/mdlDriverInfoReq";
import { mdlBindInfo_MotorCancel_Req } from "../../../Models/mdlBindInfo_MotorCancel_Req";
import { mdlDriverAddReq } from "../../../Models/mdlDriverAddReq";
import swal from "sweetalert2";
import { MotorStatusMdl } from "../../../Models/MotorStatusMdl";
import { PayfortTransInfoModel } from "../../../Models/ProposalModel";


@Component({
  selector: 'AddDrivers',
  templateUrl: './AddDrivers.html',
  styleUrls: ['./AddDrivers.css']
})

export class AddDrivers {
  public objAddSeqReq: mdlAddSequnceNoReq = new mdlAddSequnceNoReq();
  // public driverListObj: Array<MotorDriverMdl> = new Array<MotorDriverMdl>();
  public diverObj: MotorDriverMdl = new MotorDriverMdl();
  bindObj: mdlBindInfo = new mdlBindInfo();
  objmdlDriverInfoReq: mdlDriverInfoReq = new mdlDriverInfoReq();
  objmdlDriverInfoRes: mdlDriverInfoRes = new mdlDriverInfoRes();
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

  public objBindReq: mdlAddSequnceNoReq = new mdlAddSequnceNoReq();
  public objDriverAddReq: mdlDriverAddReq = new mdlDriverAddReq();
  public objMotorStatusMdl: MotorStatusMdl = new MotorStatusMdl();
  public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();

  public isShowLoading: boolean;
  public isGregorian: boolean = false;
  public isSearchSubmitted: boolean = false;
  public DriverId: string;
  public DriverMM: string;
  public DriverDD: string;
  public DriverYY: string;
  public DriverLic_ExpiryDate_Long: Date;
  public ErrorYear: boolean = false;
  public DriverLicExpYY: string;
  public DriverLicExpMM: string;
  public DriverLicExpDD: string;
  public isDriverSubmitted: boolean = false;

  public Lng: string;
  @ViewChild('closeBtn') closeBtn: ElementRef;
  constructor(private userinfo: userService, private router: Router, private url: restURL, private lngService: LanguageService, private userInfo: userService, private translate: TranslateService, private EncriptService: motorProposalService, private http: HttpClient, ) {
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    this.objAddSeqReq = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("AddDrivers")));
    this.diverObj.DriverCity = "0";
    this.diverObj.DriverEducation = "5";
    this.diverObj.DriverProfession = "1";
    this.diverObj.OtherCountriesLicenceHeld = "0";
    this.diverObj.DriverMedicalConditions = "1";
    this.diverObj.DriverMaritalStatus = "0";
    this.diverObj.DriverNationality = "0";
    this.diverObj.Ismaindriver = "1";
    this.diverObj.Drivergender = "0";
    this.diverObj.RelationWithInsured = "0";
    this.diverObj.RoadConvictions = 74;
    this.diverObj.DriverChildrenYears = "1";
    this.diverObj.SaudiLicenceHeld = "0";
    this.diverObj.OtherCountriesLicenceHeld = "341";
    this.diverObj.NumberOfYearsEachCountry = "1";
    this.diverObj.DriverMedicalConditions = "7";
    this.diverObj.OfficeCity = 0;

    if (sessionStorage.getItem(this.objAddSeqReq.PolicyNo + "_Ad") != null) {
      this.bindObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem(this.objAddSeqReq.PolicyNo + "_Ad")));
    }
    else {
      this.BindInfo();
    }

  }


  BindInfo() {
    this.isShowLoading = true;
    // let RegNo :string = this.userinfo.EncriptString(sessionStorage.getItem("RegNo")).toString();
    this.objBindReq.RegNo = this.userinfo.EncriptString(sessionStorage.getItem("RegNo")).toString();
    this.objBindReq.PolicyNo = this.objAddSeqReq.PolicyNo;
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objBindReq));

    //this.http.post<BindMdl>(this.url.baseURL + "/newPolicy/bindInfo", this.newPolicyReq, this.userinfo.getHttpOptions())
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/newPolicy/bindInfoDriverAdd", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.isShowLoading = false;
        this.objPayloadResponse = result;
        this.bindObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        if (this.bindObj.RegNo != sessionStorage.getItem("RegNo")) {
          Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
          this.router.navigate(['BeforeLogin/NewReg']);
          return;
        }

      },
        (error) => {
          this.isShowLoading = false;
          this.userinfo.checkTokenStatus(error);
        })


  }
  SetDOBType(ID) {
    var IDType: string;
    IDType = ID;
    if (IDType != "") {
      if (IDType.charAt(0) == "1") {
        this.isGregorian = false;
      }
      else {
        this.isGregorian = true;
      }
    }
  }

  DriverSearch(valid) {
    this.isSearchSubmitted = true;

    let DriverCount: number = 0;
    DriverCount = this.bindObj.driverListObj.length;
    let DriverLimit: number = 3;


    if (DriverCount >= DriverLimit) {
      this.Lng == "ar" ? Swal("لا يمكنك إضافة أكثر من ثلاثة سائقين ") : Swal("You can't add more than " + DriverLimit + " drivers")
      return;
    }

    let DriverLicCount: number = 0;

    DriverLicCount = this.bindObj.driverListObj.filter(t => t.DriverLicenseNo == this.DriverId).length;

    if (DriverLicCount > 0) {
      this.Lng == "ar" ? Swal("بيانات السائق موجودة مسبقا") : Swal("Driver Licence No Already Existed");
      return;
    }

    if (valid) {

      this.objmdlDriverInfoReq.DriverId = this.DriverId;
      if (this.DriverId.startsWith("1")) {
        this.objmdlDriverInfoReq.IdExpiry = this.DriverMM + "-" + this.DriverYY;
        this.objmdlDriverInfoReq.DOB = '';
      }
      else {
        this.objmdlDriverInfoReq.DOB = this.DriverMM + "-" + this.DriverYY;
        this.objmdlDriverInfoReq.IdExpiry = '';
      }
      this.isShowLoading = true;

      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlDriverInfoReq));

      //this.http.post<mdlDriverInfoRes>(this.url.baseURL + "/DriverInfo/GetDriverInfo_New", this.objmdlDriverInfoReq, this.userinfo.getHttpOptions())
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "/DriverInfo/GetDriverInfo_New", this.objPayloadRequest, this.userinfo.getHttpOptions())
        .toPromise().then((result) => {
          this.isShowLoading = false;

          //New Line Start
          this.objPayloadResponse = result;
          this.objmdlDriverInfoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
          //NewLine End


          if (this.objmdlDriverInfoRes.Status.StatusCode == "F") {
            Swal(this.translate.instant(this.objmdlDriverInfoRes.Status.StatusDecEn))
          }
          else {
            this.diverObj.DriverNameAr = this.objmdlDriverInfoRes.ArabicFullName;
            this.diverObj.DriverNameEn = this.objmdlDriverInfoRes.EnglishFullName;
            this.diverObj.DriverLic_ExpiryDate = '';
            this.diverObj.DriverNationality = this.objmdlDriverInfoRes.NationalityCode;
            this.diverObj.DriverLicenseNo = this.objmdlDriverInfoReq.DriverId;
            this.diverObj.DriverDOB = this.objmdlDriverInfoRes.DateOfBirth;

            this.diverObj.DriverCity = this.objmdlDriverInfoRes.IDCityCode;
            this.diverObj.DriverMaritalStatus = this.objmdlDriverInfoRes.DriverMaritalStatus;
            if (this.diverObj.DriverCity != null) {
              this.ResCityChange(this.diverObj.DriverCity);
            }
            else {
              this.diverObj.DriverCity = "0";
            }

            this.diverObj.Driver_Age = this.objmdlDriverInfoRes.DriverAge;
            if (this.objmdlDriverInfoRes.Gender != null) {
              this.diverObj.Drivergender = this.objmdlDriverInfoRes.Gender == "M" ? "1" : "2";
            }

            if (Number(this.diverObj.Driver_Age) < 17 || Number(this.diverObj.Driver_Age) > 100) {
              //this.isError = true;
              //this.ErrorMsg = "Driver Age must be between 17 and 100 only"
              this.Lng == "ar" ? Swal("يجب أن يكون عمر السائق بين 17 و 100 عام") : Swal("Driver Age must be between 17 and 100 only");
              this.diverObj.DriverNationality = '';
              this.diverObj.DriverLicenseNo = '';
              this.DriverId = '';
              this.DriverMM = '';
              this.DriverYY = ''
              this.diverObj.DriverCity = '';
              this.diverObj.DriverNameAr = "";
              this.diverObj.DriverNameEn = "";
              this.closeBtn.nativeElement.click();
            }
            else {
              if (Number(this.diverObj.Driver_Age) < 25) {
                this.diverObj.DriverLicenseType = "8";
              }
              else {
                this.diverObj.DriverLicenseType = "9";
              }

            }
          }

        },
          (error) => {
            this.isShowLoading = false;
            this.userinfo.checkTokenStatus(error);

          });

    }
  }

  CheckLicenseExpiry() {
    let CurrentDate: Date;
    CurrentDate = new Date();
    if (this.DriverLic_ExpiryDate_Long < CurrentDate) {
      this.DriverLic_ExpiryDate_Long = null;
      this.Lng == "en" ? Swal("License Expiry Date Must be Greater than Current Date") : Swal("License Expiry Date Must be Greater than Current Date");
    }


  }

  ValidateYear(val) {
    if (val < 1400 || val > 1522) {
      this.ErrorYear = true;
    } else {
      this.ErrorYear = false;
    }
  }

  ValidateSpecialChar(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  OfficeCityChange(val) {
    this.diverObj.OfficeZone = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
  }

  ResCityChange(val) {
    this.diverObj.ResidenceZone = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
  }

  AddNewDriver(valid) {
    if (!valid) {
      this.isDriverSubmitted = true;
      return;
    }
    this.isDriverSubmitted = true;
    if (this.ErrorYear) {
      return;
    }

    if (valid) {



      let newDriverObj: MotorDriverMdl = new MotorDriverMdl();
      let DriverLicCount: number = 0;
      let DriverCount: number = 0;
      let mainDriverCount: number = 0;

      let DriverLimit: number = 3;


      let DrivePer: number = 0;
      DrivePer = this.bindObj.driverListObj.reduce((a: number, b) => a + Number(b.DriverUsagePercentage), 0);
      DrivePer = Number(DrivePer) + Number(this.diverObj.DriverUsagePercentage);

      if (DrivePer > 100) {
        Swal("Maximum Total Driver Usage Percenatege is 100%");
        return;
      }
      DriverCount = this.bindObj.driverListObj.length;
      if (DriverCount > DriverLimit) {
        this.Lng == "ar" ? Swal("لا يمكنك إضافة أكثر من ثلاثة سائقين ") : Swal("You can't add more than " + DriverLimit + " drivers");
      }
      else {
        DriverLicCount = this.bindObj.driverListObj.filter(t => t.DriverLicenseNo == this.diverObj.DriverLicenseNo).length;
        if (DriverLicCount == 0) {
          if (this.diverObj.Ismaindriver == "1") {
            mainDriverCount = this.bindObj.driverListObj.filter(t => t.Ismaindriver == "1").length;
          }
          if (mainDriverCount > 0) {
            this.Lng == "ar" ? Swal(" يسمح بإضافة سائق رئيسي واحد فقط ") : Swal("Only one main Driver is allowed to add");

          }
          else {
            newDriverObj.Ismaindriver = this.diverObj.Ismaindriver;
            newDriverObj.DriverLicenseNo = this.diverObj.DriverLicenseNo;
            newDriverObj.DriverDOB = this.diverObj.DriverDOB;

            if (this.diverObj.Ismaindriver == "1") {
              newDriverObj.isMainDriverEn = "Yes";
              newDriverObj.isMainDriverEn = "Yes";
            }
            else if (this.diverObj.Ismaindriver == "2") {
              newDriverObj.isMainDriverEn = "No";
              newDriverObj.isMainDriverEn = "No";
            }
            else {
              this.Lng == "ar" ? Swal("الرجاء اختيار هل سائق رئيسي ") : Swal("Please select  Main Driver Field");
              return;
            }
            newDriverObj.DriverNameAr = this.diverObj.DriverNameAr;
            newDriverObj.DriverNameEn = this.diverObj.DriverNameEn;
            newDriverObj.DriverLic_ExpiryDate = this.diverObj.DriverLic_ExpiryDate;
            newDriverObj.DriverNationalityEn = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.diverObj.DriverNationality)[0].NationalityDescEn;
            newDriverObj.DriverNationalityAr = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.diverObj.DriverNationality)[0].NationalityDescAr;
            newDriverObj.DriverNationality = this.diverObj.DriverNationality;
            newDriverObj.DriverLicenseTypeEn = this.bindObj.LicenceTypeList.filter(t => t.LicTypecode == Number(this.diverObj.DriverLicenseType))[0].LicType_DescEn;
            newDriverObj.DriverLicenseTypeAr = this.bindObj.LicenceTypeList.filter(t => t.LicTypecode == Number(this.diverObj.DriverLicenseType))[0].LicType_DescAr;
            newDriverObj.DriverLicenseType = this.diverObj.DriverLicenseType;
            newDriverObj.DriverMaritalStatusEn = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.diverObj.DriverMaritalStatus)[0].MarstatusDesc_En;
            newDriverObj.DriverMaritalStatusAr = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.diverObj.DriverMaritalStatus)[0].MarstatusDesc_Ar;
            newDriverObj.DriverMaritalStatus = this.diverObj.DriverMaritalStatus;
            newDriverObj.DriverCity = this.diverObj.DriverCity;
            newDriverObj.DriverEducation = this.diverObj.DriverEducation;
            newDriverObj.SaudiLicenceHeld = this.diverObj.SaudiLicenceHeld;
            newDriverObj.DriverProfession = this.diverObj.DriverProfession;
            newDriverObj.DriverChildrenYears = this.diverObj.DriverChildrenYears;
            newDriverObj.OtherCountriesLicenceHeld = this.diverObj.OtherCountriesLicenceHeld;
            newDriverObj.NumberOfYearsEachCountry = this.diverObj.NumberOfYearsEachCountry;
            newDriverObj.DriverMedicalConditions = this.diverObj.DriverMedicalConditions;
            newDriverObj.DriverAddress = this.diverObj.DriverAddress;
            newDriverObj.Drivergender = this.diverObj.Drivergender;
            newDriverObj.RelationWithInsured = this.diverObj.RelationWithInsured;
            newDriverObj.Driver_Age = this.diverObj.Driver_Age;

            newDriverObj.ResidenceAdditionalNumber = this.diverObj.ResidenceAdditionalNumber;
            newDriverObj.ResidenceBuildingNumber = this.diverObj.ResidenceBuildingNumber;
            newDriverObj.ResidenceCity = Number(this.diverObj.DriverCity);
            newDriverObj.ResidenceDistrict = this.diverObj.ResidenceDistrict;
            newDriverObj.ResidenceStreet = this.diverObj.ResidenceStreet;
            newDriverObj.ResidenceUnitNumber = this.diverObj.ResidenceUnitNumber;
            newDriverObj.ResidenceZipCode = this.diverObj.ResidenceZipCode;
            newDriverObj.ResidenceZone = this.diverObj.ResidenceZone;

            newDriverObj.OfficeBuildingNumber = this.diverObj.OfficeBuildingNumber;
            newDriverObj.OfficeCity = this.diverObj.OfficeCity;
            newDriverObj.OfficeDistrict = this.diverObj.OfficeDistrict;
            newDriverObj.OfficeStreet = this.diverObj.OfficeStreet;
            newDriverObj.OfficeUnitNumber = this.diverObj.OfficeUnitNumber;
            newDriverObj.OfficeZipCode = this.diverObj.OfficeZipCode;
            newDriverObj.OfficeZone = this.diverObj.OfficeZone;
            newDriverObj.OfficeAdditionalNumber = this.diverObj.OfficeAdditionalNumber;
            newDriverObj.RoadConvictions = this.diverObj.RoadConvictions;
            newDriverObj.DriverUsagePercentage = this.diverObj.DriverUsagePercentage;
            newDriverObj.IsMandatory = 0;

            if (this.diverObj.DriverLicenseNo) {
              if (this.diverObj.DriverLicenseNo.startsWith("1")) {
                newDriverObj.DriverIDType = "1";
              }
              else {
                newDriverObj.DriverIDType = "2";
              }
            }

            if (this.Lng == "en") {
              newDriverObj.LangFlag = "E";
            }
            else {
              newDriverObj.LangFlag = "A";
            }

            this.bindObj.driverListObj.push(newDriverObj);
            this.Lng == "ar" ? Swal("تمت إضافة بيانات السائق بنجاح") : Swal("Driver added successfully");

            this.diverObj.Ismaindriver = "1";
            this.diverObj.DriverLicenseNo = "";
            this.diverObj.DriverDOB = "";
            this.diverObj.DriverNameAr = "";
            this.diverObj.DriverNameEn = "";
            this.diverObj.DriverLic_ExpiryDate = "";

            this.diverObj.DriverAddress = "";
            this.diverObj.Drivergender = "0";
            this.diverObj.RelationWithInsured = "0";
            this.diverObj.DriverNationality = "0";
            this.diverObj.DriverLicenseType = "0";
            this.diverObj.Driver_Age = "0";
            this.DriverId = "";
            this.DriverDD = "";
            this.DriverMM = "";
            this.DriverYY = "";
            this.DriverLicExpDD = "";
            this.DriverLicExpMM = "";
            this.DriverLicExpYY = "";
            this.DriverLic_ExpiryDate_Long = null;
            this.diverObj.DriverMaritalStatus = '0';

            this.diverObj.ResidenceAdditionalNumber = null;
            this.diverObj.ResidenceBuildingNumber = null;
            this.diverObj.DriverCity = "0";
            this.diverObj.ResidenceDistrict = "";
            this.diverObj.ResidenceStreet = "";
            this.diverObj.ResidenceUnitNumber = null;
            this.diverObj.ResidenceZipCode = null;
            this.diverObj.ResidenceZone = "";


            this.diverObj.OfficeAdditionalNumber = null;
            this.diverObj.OfficeBuildingNumber = null;
            this.diverObj.OfficeCity = 0
            this.diverObj.OfficeDistrict = "";
            this.diverObj.OfficeStreet = "";
            this.diverObj.OfficeUnitNumber = null;
            this.diverObj.OfficeZipCode = null;
            this.diverObj.OfficeZone = "";


            this.diverObj.DriverEducation = "5";
            this.diverObj.SaudiLicenceHeld = "0";
            this.diverObj.DriverProfession = "1";
            this.diverObj.OtherCountriesLicenceHeld = "341";
            this.diverObj.DriverMedicalConditions = "7";
            this.diverObj.RoadConvictions = 74;
            this.diverObj.DriverChildrenYears = "1";
            this.diverObj.NumberOfYearsEachCountry = "1";


            this.closeBtn.nativeElement.click();


            sessionStorage.setItem(this.objAddSeqReq.PolicyNo + "_Ad", this.EncriptService.EncriptObject(JSON.stringify(this.bindObj)));


          }
        }
        else {
          this.Lng == "ar" ? Swal("بيانات السائق موجودة مسبقا") : Swal("Driver Licence No Already Existed");
        }
      }
    }


  }

  removeDriver(index) {
    this.bindObj.driverListObj.splice(index, 1);
    sessionStorage.setItem(this.objAddSeqReq.PolicyNo + "_Ad", this.EncriptService.EncriptObject(JSON.stringify(this.bindObj)));
  }

  SubmitDrivers() {
    if (this.bindObj.driverListObj.filter(t => t.IsMandatory == 0).length == 0) {
      Swal(this.translate.instant("Please Add Drivers"));
      return;
    }

    this.objDriverAddReq.RegNo = this.userinfo.EncriptString(sessionStorage.getItem("RegNo")).toString();
    this.objDriverAddReq.PolicyNo = this.objAddSeqReq.PolicyNo;
    this.objDriverAddReq.driverListObj = this.bindObj.driverListObj;
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objDriverAddReq));
    this.isShowLoading = true;

    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/newPolicy/AddDrivers", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.isShowLoading = false;
        this.objPayloadResponse = result;
        this.transObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

        Swal(this.translate.instant(this.transObj.st.StatusDesc));

        if (this.transObj.st.StatusCode == "S") {
          // this.router.navigate(['NewDashboard/Policy']);
          // return;
          if (Number(this.transObj.Premium) > 0) {
            sessionStorage.setItem("NavFrom", "PR");
            sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
            sessionStorage.setItem("CurrentRoute", "PayfortPayment");
            this.router.navigate(['/NewDashboard/PayfortPayment']);
            return;
          }
          else {
            this.router.navigate(['NewDashboard/Policy']);
            return;
          }

        }

      },
        (error) => {
          this.isShowLoading = false;
          this.userinfo.checkTokenStatus(error);
          Swal(this.translate.instant(error));
        })
  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/AddDrivers/AddDrivers.ts